import styled from "styled-components";
import { mediaMaxWidth } from "../../../theme/mediaQueriesTemplates";

interface IWrapperProps {
  noData: boolean;
}

export const Wrapper = styled.div`
  margin: 10px;
  display: flex;
  flex-direction: column;
  background-color: #fff;
  padding: 10px;
  border-radius: 8px;
  height: 245px;
  width: calc(100% - 400px);
  position: relative;
  box-shadow: rgb(220, 220, 220) 0px 0px 15px;
  overflow: hidden;
  word-break: break-word;

  ${mediaMaxWidth.smallDesktop} {
    flex: unset;
    height: 220px;
    margin: 10px auto;
    width: 650px;
    height: ${(props: IWrapperProps) => props.noData && "unset"};
  }

  ${mediaMaxWidth.tablet} {
    width: calc(100vw - 20px);
    height: 250px;
  }

  ${mediaMaxWidth.phone} {
    height: 300px;
    height: ${(props: IWrapperProps) => props.noData && "245px"};
  }

  ${mediaMaxWidth.smallPhone} {
    height: 350px;
    height: ${(props: IWrapperProps) => props.noData && "245px"};
  }
`;

export const Title = styled.div`
  border-bottom: 1px solid #d8d8d8;
  color: #333;
  font-weight: 600;
  font-size: 1em;
  padding: 5px 10px;
  display: flex;
  justify-content: space-between;

  ${mediaMaxWidth.phone} {
    padding: 5px;
    font-size: 0.9em;
  }
`;

interface IBodyProps {
  noData: boolean;
}

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  font-size: 0.95em;
  padding: 10px 10px 0 10px;
  justify-content: ${(props: IBodyProps) => props.noData && "center"};
  align-items: ${(props: IBodyProps) => props.noData && "center"};

  p {
    font-size: unset;
  }

  ${mediaMaxWidth.smallDesktop} {
    padding: ${(props: IBodyProps) => props.noData && "85px 30px !important"};
    text-align: ${(props: IBodyProps) => props.noData && "center"};
  }

  ${mediaMaxWidth.phone} {
    padding: 10px 5px 0 5px;
  }
`;

export const ReadMore = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #fff;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;

  ${mediaMaxWidth.smallDesktop} {
    height: 60px;
  }
`;

export const ReadMoreButton = styled.div`
  cursor: pointer;
  text-decoration: underline;
  font-size: 0.85em;
  text-transform: capitalize;

  &:hover {
    color: #f2008c;
  }
`;
